import { AjaxSolr } from "../../core/Core.js";
import "../../core/AbstractWidget.js";

(function ($) {
    AjaxSolr.ResultListWidget = AjaxSolr.AbstractWidget.extend({
        constructor: function (attributes) {
            AjaxSolr.SynerisPathWidget.__super__.constructor.apply(this, arguments);
            AjaxSolr.extend(this, {
                listTemplate: undefined
            }, attributes);
        },
        beforeRequest: function () {
            let self = this;
            let $target = $(self.target);
            self.clearUI();
            let top = "-" + ($target.outerHeight() - 80).toString() + "px";
            let left = (($target.outerWidth() / 2) - 24).toString() + "px";
            $("<img style='position:relative;top:" + top + ";left:" + left + "' src='assets/images/loading_image.gif' class='synAjaxLoad_animation' />").insertAfter($target);
            $target.kendoListView({
                template: kendo.template(self.listTemplate),
                autoBind: false,
                dataSource: new kendo.data.DataSource({ data: [] })
            });
        },
        clearUI: function () {
            let $target = $(this.target);
            $target.addClass("baseWidget");
            $target.addClass("resultListWidget");
            let listView = $target.data("kendoListView");
            if (listView)
                listView.dataSource.data([]);
        },

        afterRequest: function () {
            let $target = $(this.target);
            let manager = this.manager;
            let listView = $target.data("kendoListView");
            if (listView)
                listView.dataSource.data(this.manager.response.response.docs);
        },
        cleanUp: function () {
            let $target = $(this.target);
            $target.next(".synAjaxLoad_animation").remove();
        }
    });
})(jQuery);